// extracted by mini-css-extract-plugin
module.exports = {"banner":"NoodleIsNowGladeBanner_banner__d7HWP"};